import { render, staticRenderFns } from "./VersionJoin.vue?vue&type=template&id=11e0a305&scoped=true"
import script from "./VersionJoin.vue?vue&type=script&lang=js"
export * from "./VersionJoin.vue?vue&type=script&lang=js"
import style0 from "./VersionJoin.vue?vue&type=style&index=0&id=11e0a305&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e0a305",
  null
  
)

export default component.exports